<template>
  <!-- ============================================================
       No.9 (B) 代行者権限付与：代行者用のヘッダーメニュー
       代行者に見せるのは「代行者ページ」「問合せ」「ログアウト」のみ
       （申請履歴・設定は代行者には存在しない）。
       ============================================================ -->
  <div class="menuLabel flex flexRight flexMiddle">
    <b-nav-item
      :class="menuName === 'inquiry' ? '' : 'activeNav'"
      to="/agent/top"
      right>代行者ページ</b-nav-item>
    <b-nav-item
      :class="menuName === 'inquiry' ? 'activeNav' : ''"
      to="/agent/inquiry/list"
      right>問合せ</b-nav-item>
    <span
      @click="kickLogout"
      class="logout px-3"
      >ログアウト</span>
  </div>
</template>

<script>
export default {
  name: 'AgentHeader',
  props: {
    menuName: { type: String, default: '' },
  },
  methods: {
    kickLogout() {
      this.$emit('kickLogout');
    },
  },
};
</script>

<style scoped>
  .logout {
    border: solid;
    border-width: 0 0 0 1px;
    border-color: #ccc;
  }

  .logout:hover {
    cursor: pointer;
    opacity: 0.7;
  }

  /* b-nav-item は li で描画されるためマーカーを消す（申請者ヘッダーと同じ指定） */
  .menuLabel>li{
    list-style: none;
  }
</style>
